<template>
  <v-menu dense offset-y v-bind="$attrs">
    <template v-slot:activator="{ on }">
      <slot :name="'activator'" :on="on">
        <v-btn v-on="on">BUTTON</v-btn>
      </slot>
    </template>
    <v-list dense class="menu-button">
      <v-list-item
        v-for="(item, idx) in items"
        :key="idx"
        @click="ItemClick(item)"
        :class="item ? '' : 'menu-separator'"
      >
        <v-list-item-icon>
          <v-icon
            v-if="item"
            v-text="item.icon"
            :style="{ color: item.color }"
          ></v-icon>
        </v-list-item-icon>
        <v-list-item-content style="padding: 6px 0">
          <v-list-item-title v-if="item" :style="{ color: item.color }">
            {{ item.text ? item.text : item }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    items: Array,
    default: [],
  },
  methods: {
    ItemClick(txt) {
      this.$emit('click', txt)
    },
  },
}
</script>
<style lang="scss">
.menu-button {
  .v-list-item {
    min-height: 20px;
    .v-list-item__icon {
      height: 24px;
      margin-top: 2px;
      margin-bottom: 2px;
      position: relative;
      left: -5px;
      &:first-child {
        margin-right: 4px;
        font-size: 12px;
      }
    }
  }
  .v-list-item__content {
    padding: 6px 6px 6px 0px;
  }
  .menu-separator {
    min-height: 1px;

    .v-list-item__content {
      height: 1px;
      border-top: 1px solid silver;
      margin-top: 6px;
    }
  }
}
</style>
